import { render, staticRenderFns } from "./newProjectDialog.vue?vue&type=template&id=31a2eada&scoped=true&"
import script from "./newProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./newProjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./newProjectDialog.vue?vue&type=style&index=0&id=31a2eada&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2eada",
  null
  
)

export default component.exports